export default __webpack_public_path__ + "media/images/map-bg-bf602ca7efde9b1832b29af7220db0e6.png";